export default {
  title: 'USSD reports',
  tableHeaderActionTooltip: 'Create new USSD report',
  dialog: {
    title: {
      generateReport: 'Generate USSD report',
      deleteReport: 'Delete USSD report',
      cancelReport: 'Cancel USSD report',
      regenerateReport: 'Regenerate USSD report',
      retryReport: 'Retry USSD report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate USSD report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Report name',
    placeholder: 'Enter USSD report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'Enter starting date'
    },
    endDate: {
      label: 'End date',
      placeholder: 'Enter end date'
    },
    shortcodes: {
      label: 'Shortcodes',
      placeholder: 'Select shortcodes'
    },
    operationIds: {
      label: 'Session Ids',
      placeholder: 'Select session Ids'
    },
    phoneNumbers: {
      label: 'Phone number(s)',
      placeholder: 'Select phone number(s)'
    },
    operators: {
      label: 'Operator',
      placeholder: 'Select operators'
    },
    sessionTypes: {
      label: 'Session type(s)',
      placeholder: 'Select session types'
    },
    sessionTags: {
      label: 'Session tag(s)',
      placeholder: 'Select session tags',
      helperText:
        // eslint-disable-next-line max-len
        "By pressing 'Enter' you can provide multiple values. If you want to filter rows without a session tag, add the tag 'NO_TAG'"
    },
    sessionCloseReasons: {
      label: 'Session close reason(s)',
      placeholder: 'Select session close reasons'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    shortcodes: {
      label: 'Shortcode(s)'
    },
    operationIds: {
      label: 'Session Id(s)'
    },
    phoneNumbers: {
      label: 'Phone number(s)'
    },
    operators: {
      label: 'Operator(s)'
    },
    sessionTypes: {
      label: 'Session type(s)'
    },
    sessionTags: {
      label: 'Session tag(s)',
      helperText:
        // eslint-disable-next-line max-len
        "By pressing 'Enter' you can provide multiple values. If you want to filter sessions without tag, add tag 'NO_TAG'\""
    },
    sessionCloseReasons: {
      label: 'Session close reason(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
